import { useQuery, UseQueryResult, UseQueryOptions } from '@tanstack/react-query';

import { eventEditorQueryKeys } from '@event-editor/queryKeys';
import { eventSessionsApi } from '@event-editor/api/eventSessions';
import { EditableEvent, EditableSession, EventType } from 'types/event.types';

interface SessionsQueryOptions
  extends Omit<UseQueryOptions<EditableSession[], Error>, 'queryKey' | 'queryFn'> {
  sortParams?: Parameters<typeof eventSessionsApi.listEditorSessions>['0']['sortParams'];
}

export const useSessionsQuery = (
  event: EditableEvent,
  { sortParams, ...options }: SessionsQueryOptions = {}
): UseQueryResult<EditableSession[], Error> => {
  const isMulti = event.eventType === EventType.MULTI_SESSIONS;

  return useQuery({
    queryKey: [...eventEditorQueryKeys.eventSessions(event.id!), sortParams],
    queryFn: () => eventSessionsApi.listEditorSessions({ eventId: event.id!, sortParams }),
    enabled: typeof event.id === 'number' && event.id > 0 && isMulti,
    ...options
  });
};
